import { createStore, createStateHook, createActionsHook } from 'react-sweet-state';
import type {
	Action,
	BoundActions,
	HookActionsFunction,
	HookStateFunction,
	Store,
} from 'react-sweet-state';

import type { AutoFocusTargetOptions } from './types.ts';

type PublishModalMountStateType = {
	shouldDisplayPublishModal: boolean;
	initialFocusTarget: AutoFocusTargetOptions;
};
type PublishModalMountActionsType = {
	openPublishModal: () => Action<PublishModalMountStateType, void, void>;
	closePublishModal: () => Action<PublishModalMountStateType, void, void>;
	setInitialFocusTarget: (
		newFocusTarget: AutoFocusTargetOptions,
	) => Action<PublishModalMountStateType, void, void>;
};

export const PublishModalMountStore: Store<
	PublishModalMountStateType,
	PublishModalMountActionsType
> = createStore<PublishModalMountStateType, PublishModalMountActionsType>({
	name: 'PublishModalMountStore',
	initialState: {
		shouldDisplayPublishModal: false,
		initialFocusTarget: undefined,
	},
	actions: {
		openPublishModal:
			() =>
			({ setState }) =>
				setState({ shouldDisplayPublishModal: true }),
		closePublishModal:
			() =>
			({ setState }) =>
				setState({ shouldDisplayPublishModal: false }),
		setInitialFocusTarget:
			(newFocusTarget) =>
			({ setState }) =>
				setState({ initialFocusTarget: newFocusTarget }),
	},
});

export const usePublishModalMountStore: HookStateFunction<PublishModalMountStateType, void> =
	createStateHook(PublishModalMountStore);
export const usePublishModalMountActions: HookActionsFunction<
	BoundActions<PublishModalMountStateType, PublishModalMountActionsType>
> = createActionsHook(PublishModalMountStore);
